module.exports = __webpack_public_path__ + "img/props-img2.35a60efe.png";